import { render, staticRenderFns } from "./RepresentativeFormComponent.vue?vue&type=template&id=f05ffd2e"
import script from "./RepresentativeFormComponent.vue?vue&type=script&lang=js"
export * from "./RepresentativeFormComponent.vue?vue&type=script&lang=js"
import style0 from "./RepresentativeFormComponent.vue?vue&type=style&index=0&id=f05ffd2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports